export default __webpack_public_path__ + "static/media/nantes2.de97a3f9.jpg";